import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import { formatMoney } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../components/Sticky"
import store from "../store"
import { buildCart } from "../utils/Shopify"

export default class ShopAllSamples extends Component {
  constructor(obj) {
    super(obj)

    this.selectedItemsWrapper = qs(".selected-items-list", this.el)
    this.right = qs(".right", this.el)
    this.samples = qsa(".sample-item", this.el)
    this.addToCart = qs(".shop-all-samples-cta", this.el)
    this.addToCartMobile = qs(".shop-all-samples-cta-mobile", this.el)
    this.loadingBg = qs(".loading-bg", this.el)
    this.mobileWrapper = qs(".mobile-cta", this.el)

    this.selectedSamples = []

    const stickyContent = qs(".sticky-content", this.el)

    const sticky = new Sticky({
      el: this.el,
      sticky: stickyContent,
      isSmooth: store.flags.isSmooth,
      // onUpdateCallback: self => {
      //   console.log("update", self.progress)
      // },
    })

    sticky.resize()

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const title = qsa(".left .label .char-1", this.el)
    const number = qs(".left .number", this.el)
    const samples = qsa(".sample-item", this.el)

    gsap.from(title, {
      y: "100%",
      duration: 1.2,
      stagger: 0.03,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(number, {
      y: "100%",
      duration: 1.2,
      autoAlpha: 0,
      delay: 0.3,
      scrollTrigger: {
        trigger: number,
        start: "top bottom",
      },
    })

    gsap.from(samples, {
      y: "100%",
      duration: 1.2,
      autoAlpha: 0,
      stagger: 0.1,
      scrollTrigger: {
        trigger: samples,
        start: "top bottom",
      },
    })
    gsap.set(this.el, { autoAlpha: 1 })
  }

  on() {
    this.addToCartMobile.addEventListener("click", this.addAllToCart)
    this.addToCart.addEventListener("click", this.addAllToCart)

    this.samples.forEach((sample, index) => {
      sample.addEventListener("click", () => this.selectSample(index))
    })
  }

  selectSample = index => {
    this.loadingBg.classList.add("loading-bg_active")

    this.samples[index].classList.toggle("sample-item_selected")

    const name = this.samples[index].querySelector(".data-name").innerHTML
    const rawPrice = this.samples[index].querySelector(".new-price").innerHTML
    const price = parseFloat(rawPrice.replace(/[^\d,.-]/g, "").replace(",", "."))
    const variantId = this.samples[index].getAttribute("data-variant-id")

    const src = this.samples[index].querySelector("img").getAttribute("src")

    // Find if the index is already in selectedSamples
    const existingIndex = this.selectedSamples.findIndex(item => item.index === index)

    if (existingIndex !== -1) {
      // Already exists → remove it
      this.selectedSamples.splice(existingIndex, 1)
    } else {
      // Not in array → add it
      this.selectedSamples.push({
        index: index,
        price: price,
        name: name,
        quantity: 1,
        img: src,
        variantId,
      })
    }

    this.updateSelectedList()
  }

  addAllToCart = async () => {
    this.loadingBg.classList.add("loading-bg_active")

    const items = this.selectedSamples.map(sample => ({
      id: sample.variantId,
      quantity: sample.quantity,
    }))

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      })

      const result = await response.json()
      this.loadingBg.classList.remove("loading-bg_active")

      // console.log("Added to cart:", result)

      buildCart()

      // Optional: redirect or open cart drawer
      // window.location.href = '/cart'
    } catch (err) {
      console.error("Error adding to cart:", err)
      this.loadingBg.classList.remove("loading-bg_active")
    }
  }

  updateSelectedList = () => {
    // Clear the list first

    this.loadingBg.classList.add("loading-bg_active")

    if (this.selectedSamples.length > 0) {
      this.right.classList.add("right_active")
      this.mobileWrapper.classList.add("mobile-cta_active")
    } else {
      this.right.classList.remove("right_active")
      this.mobileWrapper.classList.remove("mobile-cta_active")
    }

    this.addToCartMobile.innerHTML = `Add ${this.selectedSamples.length} selected samples to cart`

    this.selectedItemsWrapper.innerHTML = ""

    this.selectedSamples.forEach(selectedSample => {
      const node = this.buildHtml(selectedSample)
      this.selectedItemsWrapper.appendChild(node)
    })
    setTimeout(() => {
      this.loadingBg.classList.remove("loading-bg_active")
    }, 200)

    const titleHeight = bounds(qs(".label", this.right)).height

    this.loadingBg.style.height = bounds(this.selectedItemsWrapper).height + 40 + 48 + 40 + 40 + 32 + titleHeight + "px"
  }

  buildHtml = sample => {
    const displayedPrice = Number(sample.price * sample.quantity).toFixed(2) // Returns a string like "596.85"

    const template = document.createElement("div")
    template.setAttribute("class", "selected-item")
    template.innerHTML = `
    <img src="${sample.img}" class="img cover">
    <div class="label-quantity">
      <p class="sample-name -p6">${sample.name}</p>
      <div class="quantity-wrapper">
        <button class="-p0 btn" data-type="minus" data-index="${sample.index}">-</button>
        <span class="-p0 quantity-value">${sample.quantity}</span>
        <button class="-p0 btn" data-type="plus" data-index="${sample.index}">+</button>
      </div>
    </div>
    <div class="price-remove">
      <span class="-p6 price">${formatMoney(displayedPrice, Shopify.money_format)}</span>
      <span class="-p6 remove" data-index="${sample.index}">Remove</span>
    </div>
  `.trim()

    const removeBtn = template.querySelector(".remove")
    removeBtn.addEventListener("click", e => {
      const index = parseInt(e.target.dataset.index)
      this.selectedSamples = this.selectedSamples.filter(item => item.index !== index)
      this.samples[index].classList.remove("sample-item_selected")
      this.updateSelectedList()
    })

    // Quantity controls
    const plusBtn = template.querySelector('[data-type="plus"]')
    const minusBtn = template.querySelector('[data-type="minus"]')

    plusBtn.addEventListener("click", e => {
      const index = parseInt(e.target.dataset.index)
      const sample = this.selectedSamples.find(item => item.index === index)
      if (sample) {
        sample.quantity += 1
        this.updateSelectedList()
      }
    })

    minusBtn.addEventListener("click", e => {
      const index = parseInt(e.target.dataset.index)
      const sample = this.selectedSamples.find(item => item.index === index)
      if (sample && sample.quantity > 1) {
        sample.quantity -= 1
        this.updateSelectedList()
      }
    })

    return template
  }
}
